import { interpolateColor } from './colorUtils';

// Couleurs pour les différents niveaux de sérénité
// Rouge (agité) -> Jaune (neutre) -> Vert (serein)
export const serenityColors = {
  agitated: '#f44336',  // Rouge vif pour état agité
  neutral: '#ffdd1f',   // Jaune pour état neutre
  serene: '#00f98d'     // Vert pour état serein
};

export const getSerenityColor = (score: number): string => {
  // Score de 0 à 100
  if (score <= 50) {
    // De agité (0) à neutre (50)
    return interpolateColor(serenityColors.agitated, serenityColors.neutral, score / 50);
  } else {
    // De neutre (50) à serein (100)
    return interpolateColor(serenityColors.neutral, serenityColors.serene, (score - 50) / 50);
  }
};

// Pour les graphiques et visualisations
export const serenityColorScale = [
  { value: 0, color: serenityColors.agitated },
  { value: 50, color: serenityColors.neutral },
  { value: 100, color: serenityColors.serene }
];
